import Vue from 'vue'
import App from './App.vue'
import vant from "vant"
import 'vant/lib/index.css'
import store from './store'

import router from "./router"
// import http from "./utils/http"
import request from './utils/request'
Vue.prototype.$request = request;
// Vue.use(request);
// Vue.prototype.$http = http;
Vue.config.productionTip = false
Vue.use(vant)

// 完整加载 大转盘
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
    setRemPc()
    window.addEventListener('resize', setRemPc) //浏览器窗口大小改变时调用rem换算方法
  }
}).$mount('#app')

//rem计算
function setRemPc() {
  // 获取屏幕分辨率的宽 / 20 此时20rem = 屏幕宽度
  document.documentElement.style.fontSize = window.screen.width / 8 + 'px'
}